import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import * as Objects from '@core/objects';

import { ThreeDotsMenuItem } from '@core/components/helpers/navigation/three-dots-menu/three-dots-menu-item';
import { FilesListItemMenuClick } from '@core/components/files/lists/files-list-item-menu-click';

import { UrlService } from '@core/services/url/url.service';

@Component({
    selector: 'core-versions-detail-preview-file',
    templateUrl: './detail-preview-file.component.html',
    styleUrls: ['./detail-preview-file.component.scss']
})
export class VersionsDetailPreviewFileComponent implements OnInit{


    @Input() version: Objects.Version = null;
    @Input() file: Objects.File = null;
    @Input() menu: Array<ThreeDotsMenuItem> = [];
    // for shared files to get  feedback
    @Input() notesUrlPrefix: string;
    @Input() annotationsUrlPrefix: string;
    @Input() annotationsSaveUrlPrefix: string;
    @Input() canCreateNotes: boolean;    
    @Input() context: string = 'default';
    @Input() notesAllowedUser: Objects.User = null; // when set, only the notes of this user should be displayed

    @Output() menuClick = new EventEmitter<FilesListItemMenuClick>();


    public breadcrumbs: any = [
        {
            title: "",
            link: ['']
        }
    ];


    constructor (private urlSrv: UrlService){}

    ngOnInit(): void {
    }

    onMenuClick(menu: FilesListItemMenuClick) {
        this.menuClick.emit(menu);
    }

    onActionDownloadClick(file: Objects.File){
        window.location.href = this.urlSrv.build('/files/'+file.id);
    }



}
